import script from "./ApiGoods.vue?vue&type=script&lang=ts&setup=true"
export * from "./ApiGoods.vue?vue&type=script&lang=ts&setup=true"

import "./ApiGoods.vue?vue&type=style&index=0&id=7c8acb8a&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c8acb8a"]])

export default __exports__